"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.preSprintf = void 0;
/**
 * An i18next plugin that prepares a string for sprintf by converting simple placeholders to sprintf syntax.
 *
 * This was created to support legacy translations and maintain existing functionality as we move i18n logic to this repo.
 */
const preSprintf = exports.preSprintf = {
  type: 'postProcessor',
  name: 'preSprintf',
  process: value => value.replace(/(%\d+)(\$\w)?/g, '$1$s')
};